import Navbar from "../components/Navbar";
import SiteFooter from "../components/SiteFooter";
import Seo from "../components/Seo";

export function Hero({ kicker, title, sub, desc, children, testid }) {
  return (
    <section className="pt-28 md:pt-36 pb-16 md:pb-24 border-b border-white/5" data-testid={testid}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="pill-badge pill-amber mb-5 inline-flex">{kicker}</div>
        <h1 className="headline-huge text-4xl sm:text-5xl lg:text-6xl mb-4 max-w-4xl">{title}</h1>
        {sub && <p className="text-base md:text-lg text-white/90 mb-3 max-w-2xl">{sub}</p>}
        {desc && <p className="text-sm md:text-base text-slate-400 mb-8 max-w-2xl leading-relaxed">{desc}</p>}
        <div className="flex flex-col sm:flex-row sm:flex-wrap gap-3">{children}</div>
      </div>
    </section>
  );
}

export function Section({ kicker, title, sub, children, testid, dark }) {
  return (
    <section className={`py-16 md:py-24 ${dark ? "bg-[#0B0D14] border-y border-white/5" : ""}`} data-testid={testid}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        {kicker && <div className="pill-badge mb-4 inline-flex">{kicker}</div>}
        {title && <h2 className="headline-huge text-3xl md:text-4xl mb-3 max-w-3xl">{title}</h2>}
        {sub && <p className="text-base text-slate-400 mb-10 max-w-2xl">{sub}</p>}
        {children}
      </div>
    </section>
  );
}

export function Features({ items, cols = 3 }) {
  return (
    <div className={`grid sm:grid-cols-2 lg:grid-cols-${cols} gap-4`}>
      {items.map(([Icon, t, d]) => <div key={t} className="rounded-xl border border-white/10 bg-white/[0.02] p-6 flex flex-col gap-2 hover:border-white/25 transition-colors"><Icon className="w-6 h-6 text-[#FF9F0A]" /><div className="font-display font-bold text-lg">{t}</div><div className="text-sm text-slate-400 leading-relaxed">{d}</div></div>)}
    </div>
  );
}

export function Steps({ items }) {
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {items.map(([t, d], i) => <div key={t} className="rl-card p-6"><div className="font-mono-rl text-xs text-[#FF1E27] mb-2">PASSO {i + 1}</div><div className="font-display font-bold text-lg mb-1">{t}</div><div className="text-sm text-slate-400">{d}</div></div>)}
    </div>
  );
}

export function Faq({ items }) {
  return (
    <div className="grid md:grid-cols-2 gap-x-10 gap-y-6" data-testid="faq">
      {items.map(([q, a]) => <div key={q} className="border-b border-white/5 pb-5"><div className="font-display font-bold mb-1">{q}</div><div className="text-sm text-slate-400 leading-relaxed">{a}</div></div>)}
    </div>
  );
}

export default function ProductLayout({ seo, children, testid, variant = "default" }) {
  return (
    <div className="min-h-screen grain-bg" data-testid={testid}>
      <Navbar variant={variant} />
      <Seo {...(seo || {})} />
      {children}
      <SiteFooter />
    </div>
  );
}
